module.exports = __webpack_public_path__ + "img/frame (56).0a5a462c.jpg";